import React, { useState } from 'react';
import Popover from '@material-ui/core/Popover';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import AnchorLink from 'react-anchor-link-smooth-scroll';
const HamburgerMenu = ({menus}) => {
	const [ anchorHMenuEl, setAnchorHMenuEl ] = useState(null);

	const handleHMenuClick = (e) => {
		setAnchorHMenuEl(e.currentTarget);
	};

	const handleHMenuClose = () => {
		setAnchorHMenuEl(null);
	};

	const hMenuOpen = Boolean(anchorHMenuEl);
	const id = hMenuOpen ? 'simple-popover' : undefined;

	return (
		<div>
			<IconButton onClick={handleHMenuClick}>
				<MenuIcon
					className="font-xlarge"
					aria-describedby={id}
					color="secondary"
				/>
			</IconButton>
			<Popover
				id={id}
				open={hMenuOpen}
				anchorEl={anchorHMenuEl}
				onClose={handleHMenuClose}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
			>
				{menus.map((menu, i) => <AnchorLink href={`#${menu.link}`} key={i}><MenuItem className="font-large">{menu.name}</MenuItem></AnchorLink>)}
			</Popover>
		</div>
	);
};
export default HamburgerMenu;
